module.exports = "<my-title my-label=\"$root.labels.account.createUser\"\n  my-style=\"$root.styles.titles.center\"\n  my-level=\"3\">\n</my-title>\n\n<my-new-user-form>\n</my-new-user-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/account/templates/new.html
// module id = 1473
// module chunks = 0